import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { limitItems } from 'assets/constants/records.limit';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DisplayService {

  constructor(
    protected firestore: AngularFirestore
  ) { }

  createId(): string {
    return this.firestore.createId();
  }

  createDisplay(display: any): Promise<any> {
    return this.firestore.collection("displays").doc(display.id).set(display);
  }

  updateEmployee(display: any): Promise<any> {
    return this.firestore.collection("displays").doc(display.id).update(display);
  }

  getDisplays(): Observable<any> {
    return this.firestore.collection("displays", (query) => query.limit(limitItems).orderBy("dayToShow")).valueChanges();
  }
}
